global.$ = require("jquery")

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
const application = Application.start()
const context = require.context("controllers", true, /notice_controller\.js$/)
application.load(definitionsFromContext(context))
